import { TableRow, TableCell } from "@/components/ui/table";
import { flexRender, Row } from "@tanstack/react-table";

export default function DefaultTableRow<Tdata>({
    row,
    i,
}: {
    row: Row<Tdata>;
    i: number;
}) {
    return (
        <TableRow
            key={row.id}
            className={`${
                i % 2 === 0 ? "bg-white" : "bg-gray-50"
            } transition hover:bg-gray-100`}
        >
            {row.getVisibleCells().map((cell) => {
                return (
                    <TableCell
                        key={cell.id}
                        className="border-b border-gray-200 px-4 py-2 text-center text-gray-800"
                    >
                        {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext(),
                        )}
                    </TableCell>
                );
            })}
        </TableRow>
    );
}
